import React, { useEffect } from 'react';
import {
  Box,
  VStack,
  Text,
  Icon,
  Button,
  Card,
  CardBody,
  Center,
  useColorModeValue,
} from '@chakra-ui/react';
import { FiCheck, FiArrowLeft } from 'react-icons/fi';

const DocumentSubmitted: React.FC = () => {
  const successBg = useColorModeValue('green.50', 'green.900');
  const successColor = useColorModeValue('green.600', 'green.200');

  useEffect(() => {
    // Auto-close window after 5 seconds if opened in popup
    const timer = setTimeout(() => {
      if (window.opener) {
        window.close();
      }
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  const handleReturnToPortal = () => {
    // If opened in popup, close it
    if (window.opener) {
      window.close();
    } else {
      // Otherwise redirect to vendor registration
      window.location.href = '/vendor-registration';
    }
  };

  return (
    <Box minH="100vh" bg={successBg} py={16}>
      <Center>
        <Card maxW="md" w="full" mx={4}>
          <CardBody p={12}>
            <VStack spacing={8} align="center">
              {/* Success Icon */}
              <Box
                w={20}
                h={20}
                bg="green.500"
                borderRadius="full"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <Icon as={FiCheck} color="white" boxSize={10} />
              </Box>

              {/* Success Message */}
              <VStack spacing={4} textAlign="center">
                <Text fontSize="2xl" fontWeight="bold" color={successColor}>
                  Document Submitted
                </Text>
                <Text fontSize="lg" color="gray.600">
                  Your signature has been successfully recorded.
                </Text>
                <Text fontSize="sm" color="gray.500">
                  You can now close this window and continue with your registration.
                </Text>
              </VStack>

              {/* Return Button */}
              <Button
                leftIcon={<Icon as={FiArrowLeft} />}
                colorScheme="green"
                size="lg"
                onClick={handleReturnToPortal}
                px={8}
              >
                Return to Registration
              </Button>

              {/* Auto-close note */}
              <Text fontSize="xs" color="gray.400" textAlign="center">
                This window will automatically close in 5 seconds
              </Text>
            </VStack>
          </CardBody>
        </Card>
      </Center>
    </Box>
  );
};

export default DocumentSubmitted; 